/** ***********************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 ************************************************************************* */

import React from 'react';
import BaseDialog from './baseDialog';
import SendLink from '../../components/sendLink';

// Details on properties captured in wiki page: https://wiki.corp.adobe.com/pages/viewpage.action?spaceKey=ccd&title=Send+link+to+mobile+device+Dialog+model
export default class SendLinkDialog extends BaseDialog {
    app;

    /**
     * supportedServices 					list of supported services
     */
    supportedServices;

    /**
     * adobeIDEmailAddresses 				list of adobe ID email addresses
     */
    adobeIDEmailAddresses;

    /**
     * userCountry                              country id of the user country
     */
    userCountry;

    /**
     * Callback to be executed when any action taken on the dialog
     * @type {function}
     */
    onAction;

    constructor({
        app, supportedServices, adobeIDEmailAddresses, userCountry, onAction,
    }) {
        super();
        this.app = app;
        this.supportedServices = supportedServices;
        this.adobeIDEmailAddresses = adobeIDEmailAddresses;
        this.userCountry = userCountry;
        this.onAction = onAction;
    }

    get dialogConfig() {
        return {
            render: () => <SendLink data={this} />,
            className: `send-link-dialog${this.supportedServices.length === 1 && this.supportedServices[0] === 'email' ? ' send-link-email-only' : ''}`,
        };
    }
}
